export enum PdfSettingsFooterInfoBlocksEnum {
  COMPANY = 'COMPANY',
  CONTACTS = 'CONTACTS',
  LEGAL_INFO = 'LEGAL_INFO',
  BANK_DETAILS = 'BANK_DETAILS',
}
